module.exports = __webpack_public_path__ + "src/assets/img/4_7art_2part.54c140dc.jpg";